export const LOAD_REPORTS_STARTED = "LOAD_REPORTS_STARTED";
export const LOAD_REPORTS_SUCCEEDED = "LOAD_REPORTS_SUCCEEDED";
export const LOAD_REPORTS_FAILED = "LOAD_REPORTS_FAILED";

export const LOAD_REPORT_STARTED = "LOAD_REPORT_STARTED";
export const LOAD_REPORT_SUCCEEDED = "LOAD_REPORT_SUCCEEDED";
export const LOAD_REPORT_FAILED = "LOAD_REPORT_FAILED";

export const GENERATE_REPORT_STARTED = "GENERATE_REPORT_STARTED";
export const GENERATE_REPORT_SUCCEEDED = "GENERATE_REPORT_SUCCEEDED";
export const GENERATE_REPORT_FAILED = "GENERATE_REPORT_FAILED";

export const LOAD_BROWSER_STARTED = "LOAD_BROWSER_STARTED";
export const LOAD_BROWSER_SUCCEEDED = "LOAD_BROWSER_SUCCEEDED";
export const LOAD_BROWSER_FAILED = "LOAD_BROWSER_FAILED";

export const LOAD_BROWSERDATA_STARTED = "LOAD_BROWSERDATA_STARTED";
export const LOAD_BROWSERDATA_SUCCEEDED = "LOAD_BROWSERDATA_SUCCEEDED";
export const LOAD_BROWSERDATA_FAILED = "LOAD_BROWSERDATA_FAILED";
export const CLEAN_BROWSER = "CLEAN_BROWSER";
